import React from "react";
import { LAYOUTS } from "../../_utils/routes";
import { MenuItem } from "react-pro-sidebar";
import { openSidebar, closeSidebar } from "../../_actions/sidebarSliderActions";
import { redirect } from "../../_actions/commonAction";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { NO_ACCESS_TO_CREATE_STORY } from "../../_utils/constants";
import { Tooltip, IconButton, Button, Box } from "@chakra-ui/react";
import { FaPlus } from "react-icons/fa";
import { useTranslation } from "react-i18next";

function NewProject(props) {
  const { t } = useTranslation(["common"]);
  const isCollapsed = !props.sidebarSlider.isSidebarOpen;
  const hidePlusButton = props.sidebarSlider.isSidebarOpen;

  const toggle = () => {
    if (isCollapsed) {
      props.openSidebar();
    } else {
      props.closeSidebar();
    }
  };

  return (
    <Box mt={6} display={["none","none","none","block"]}>
    <MenuItem
      className="quikc-start"
      icon={
        hidePlusButton ? null : (
          <Tooltip
            hasArrow
            label={
              !props.canCreateStory
                ? NO_ACCESS_TO_CREATE_STORY
                : t("new_project")
            }
            placement="top"
          >
            <IconButton icon={<FaPlus />} variant="solid" onClick={toggle} />
          </Tooltip>
        )
      }
    >
      {hidePlusButton ? (
        <Tooltip
          hasArrow
          label={
            !props.canCreateStory ? NO_ACCESS_TO_CREATE_STORY : t("new_project")
          }
          placement="top"
        >
          <Button
            onClick={(e) => {
              // e.stopPropagation();
              if (props.canCreateStory) {
                props.redirect(LAYOUTS, { ...props });
              } else {
                // TODO: Show some popup modal
              }
            }}
            leftIcon={<FaPlus />}
            variant="solid"
            isFullWidth
          >
            {t("new_project")}
          </Button>
        </Tooltip>
      ) : null}
    </MenuItem>
    </Box>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  sidebarSlider: state.sidebarSlider,
  canCreateStory: state?.permissions?.workspacePermissionChecks.canCreateStory,
});

const mapDispatchToProps = (dispatch) => ({
  openSidebar: () => dispatch(openSidebar()),
  closeSidebar: () => dispatch(closeSidebar()),
  redirect: (location, props) => dispatch(redirect(location, props)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(NewProject));
